<template>
    <section class="container-section border-bottom" v-if="orderData != null">

        <div class="container pt-5 pt-sm-55 pt-md-65 pt-lg-7 pt-xl-75 pt-xxl-7 px-lg-5 px-xl-45 px-xxl-3 mb-6 mb-sm-65 mb-md-7 mb-lg-75 mb-xl-10">
            <div class="row">
                <div class="col-24 col-xl-16 pr-lg-4">
                    <h1 class="h2 text-uppercase text-start text-xl-left mb-0">
                        {{$root.translateString('complete_order')}}
                    </h1>

                    <div class="mt-5">

                        <span class="h3 d-inline-block mt-2 mb-5 w-100 text-primary">
                            <span class="text-smaller-">
                                01. {{$root.translateString('personal_details')}}
                            </span>
                        </span>

                        <!--<div class="d-flex align-items-center p-lg-1">
                            <img alt="login" src="/img/frontend/area-utente/user.svg" width="18"/>
                            <span class="ml-1 pl-2">
                                {{$root.translateString('have-an-account')}}
                                <a class="ml-2" href="javascript:void(0)" @click="toggleLogin">
                                    <span>{{$root.translateString('login-now')}}</span>
                                </a>
                            </span>
                        </div>-->

                        <div class="row" v-if="isLogged">
                            <div class="col-24">
                                <p class="mb-0">Hai effettuato l'accesso con il tuo account <span class="text-primary">{{userProp.email}}</span></p>
                            </div>
                        </div>

                        <div class="row" v-if="!isLogged">
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.new_user.name.state = null" v-model="new_user.name"/>
                                    <label class="placeholder h5"> {{$root.translateString('name')}}</label>
                                    <div class="pristine-error" :class="validation.new_user.name.state == false ? 'invalid' : 'd-none'">{{validation.new_user.name.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.new_user.email.state = null" v-model="new_user.email"/>
                                    <label class="placeholder h5"> Email</label>
                                    <div class="pristine-error" :class="validation.new_user.email.state == false ? 'invalid' : 'd-none'">{{validation.new_user.email.message}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row"  v-if="!isLogged">
                            <div class="col-24 col-sm-auto align-items-center">
                                <div class="form-wrapper flex-grow-1 ml-0 checkbox text-left">
                                    <input required id="privacy" type="checkbox" name="privacy" v-model="new_user.privacy"/>
                                    <span class="mb-0">
                                    <label for="privacy" class="text-grey">
                                        {{$root.translateString('acceptance')}} <a class="text-grey text-underline" :href="'/' + lang + '/privacy-policy'" target="_blank">{{$root.translateString('acceptance_link')}}</a>
                                    </label>
                                </span>
                                    <div class="pristine-error" :class="validation.new_user.privacy.state == false ? 'invalid' : 'd-none'">{{validation.new_user.privacy.message}}</div>
                                </div>
                            </div>

                            <!--<div class="col-12 col-sm-auto align-items-center">
                                <div class="form-wrapper flex-grow-1 ml-0 checkbox text-left">
                                    <input required id="create_new_account" type="checkbox" name="create_new_account" v-model="new_user.create_account"/>
                                    <span class="mb-0">
                                        <label for="create_new_account" class="text-grey">
                                            {{$root.translateString('create-new-account')}}
                                        </label>
                                    </span>
                                </div>
                            </div>-->
                        </div>

                        <!--<div class="row">
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="password" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.new_user.password.state = null" v-model="new_user.password"/>
                                    <label class="placeholder h5"> {{$root.translateString('password')}}</label>
                                    <div class="pristine-error" :class="validation.new_user.password.state == false ? 'invalid' : 'd-none'">{{validation.new_user.password.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.new_user.password_confirmation.state = null" v-model="new_user.password_confirmation"/>
                                    <label class="placeholder h5"> {{$root.translateString('password_confirmation')}}</label>
                                    <div class="pristine-error" :class="validation.new_user.password_confirmation.state == false ? 'invalid' : 'd-none'">{{validation.new_user.password_confirmation.message}}</div>
                                </div>
                            </div>
                        </div>-->

                    </div>

                    <!-- shipping -->

                    <div class="mt-5">

                        <span class="h3 d-inline-block mt-2 mb-5 w-100 text-primary">
                            <span class="text-smaller-">
                                02. {{$root.translateString('shipping_details')}}
                            </span>
                        </span>

                        <!--<div class="w-100" v-if="isLogged && (user.addresses.length >= 1 && user.addresses[0].new === false)">
                            <div class="">
                                <div class="w-100" >
                                    <div class="w-100 cursor-pointer">
                                        <div class="">
                                            <img alt="icona" src="" width="9"/>
                                        </div>
                                        <v-select
                                            @input="manageSaveAddressCheckbox"
                                            :clearable="false"
                                            v-model="address"
                                            label="label"
                                            :class="{'full' : (user.addresses != null && user.addresses != '')}"
                                            :options="user.addresses"
                                            index="value"
                                        >
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    {{$root.translateString('no_results')}} <strong>{{ search }}</strong>
                                                </template>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="flex">
                                                    <div class="w-100">
                                                        {{ option.label }}
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                {{ option.label }}
                                            </template>
                                        </v-select>
                                        <label class="placeholder h5">
                                            {{$root.translateString('select-an-address')}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>-->

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.name.state = null" v-model="orderData.data.ship.name"/>
                                    <label class="placeholder h5"> {{$root.translateString('name')}}</label>
                                    <div class="pristine-error" :class="validation.address.name.state == false ? 'invalid' : 'd-none'">{{validation.address.name.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.email.state = null" v-model="orderData.data.ship.email"/>
                                    <label class="placeholder h5"> Email</label>
                                    <div class="pristine-error" :class="validation.address.email.state == false ? 'invalid' : 'd-none'">{{validation.address.email.message}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.phone.state = null" v-model="orderData.data.ship.phone"/>
                                    <label class="placeholder h5"> {{$root.translateString('phone')}}</label>
                                    <div class="pristine-error" :class="validation.address.phone.state == false ? 'invalid' : 'd-none'">{{validation.address.phone.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input readonly type="text" required autocomplete="off" placeholder=" " value="" class="form-control" :value="lang == 'en' ? 'Italy' : 'Italia'"/>
                                    <label class="placeholder h5"> {{$root.translateString('country')}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.address.state = null" v-model="orderData.data.ship.address"/>
                                    <label class="placeholder h5"> {{$root.translateString('address')}}</label>
                                    <div class="pristine-error" :class="validation.address.address.state == false ? 'invalid' : 'd-none'">{{validation.address.address.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.city.state = null" v-model="orderData.data.ship.city"/>
                                    <label class="placeholder h5"> {{$root.translateString('city')}}</label>
                                    <div class="pristine-error" :class="validation.address.city.state == false ? 'invalid' : 'd-none'">{{validation.address.city.message}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <v-select
                                        @input="validation.address.province.state = null"
                                        v-model="orderData.data.ship.province"
                                        :class="{'full' : (orderData.data.ship.province != null && orderData.data.ship.province != '')}"
                                        :options="provinces"
                                        label="value"
                                        index="label"
                                        :reduce="label => label.label"
                                    >
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                            </template>
                                        </template>
                                    </v-select>
                                    <label class="placeholder h5"> {{$root.translateString('province')}}</label>
                                    <div class="pristine-error" :class="validation.address.province.state == false ? 'invalid' : 'd-none'">{{validation.address.province.message}}</div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                    <input type="text" required autocomplete="off" placeholder=" " value="" class="form-control" @focus="validation.address.cap.state = null" v-model="orderData.data.ship.cap"/>
                                    <label class="placeholder h5"> {{$root.translateString('cap')}}</label>
                                    <div class="pristine-error" :class="validation.address.cap.state == false ? 'invalid' : 'd-none'">{{validation.address.cap.message}}</div>
                                </div>
                            </div>
                        </div>

                        <!--<div class="row">
                            <div class="col-12 col-sm-auto align-items-center mr-3">
                                <div class="form-wrapper flex-grow-1 ml-0 checkbox text-left">
                                    <input required id="billing" type="checkbox" name="billing" v-model="user.billing.require_invoice"/>
                                    <span class="mb-0">
                                        <label for="billing" class="text-grey">
                                            {{$root.translateString('ask_for_invoice')}}
                                        </label>
                                    </span>
                                    <span class="mt-1 is-invalid"></span>
                                </div>
                            </div>
                        </div>-->

                    </div>


                    <!--<div class="checkout-container-row-2__checkbox mt-3" v-if="!hide_save_address || new_user.create_account">
                        <div class="checkbox-styles">
                            <div class="checkbox">
                                <input type="checkbox" id="save_new_address" :checked="save_new_address">
                                <label class="d-inline-block w-100" for="save_new_address" @click="save_new_address = !save_new_address"></label>
                            </div>
                            <div class="checkbox-styles__link" @click="save_new_address = !save_new_address">
                                {{$root.translateString('save-new-address')}}
                            </div>
                        </div>
                    </div>-->

                    <!-- billing -->

                    <div class="w-100 mt-45" v-if="user.billing.require_invoice">

                        <span class="h3 d-inline-block mt-2 mb-5 w-100 text-primary">
                            <span class="text-smaller-">
                                03. {{$root.translateString('invoice_details')}}
                            </span>
                        </span>

                        <div class="col-24 mt-3 mb-4 ps-2">
                            <div class="row">
                                <div class="col-auto align-items-center pl-0 mr-3">
                                    <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio text-left">
                                        <input required id="private" type="radio" name="billing-type" value="private" v-model="orderData.data.billing.type"/>
                                        <span class="mb-0">
                                            <label for="private" class="text-primary">
                                                {{$root.translateString('private')}}
                                            </label>
                                        </span>
                                        <span class="mt-1 is-invalid"></span>
                                    </div>
                                </div>
                                <div class="col-auto align-items-center mr-3">
                                    <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio text-left">
                                        <input required id="company" type="radio" name="billing-type" value="company" v-model="orderData.data.billing.type"/>
                                        <span class="mb-0">
                                        <label for="company" class="text-primary">
                                            {{$root.translateString('company')}}
                                        </label>
                                    </span>
                                        <span class="mt-1 is-invalid"></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="orderData.data.billing.type == 'company'">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                        <input class="form-control" placeholder=" " type="text" v-model="orderData.data.billing.name" @focus="validation.billing.name.state = null">
                                        <label class="placeholder h5"> {{$root.translateString('company_name')}} </label>
                                        <div class="pristine-error" :class="validation.billing.name.state == false ? 'invalid' : 'd-none'">{{validation.billing.name.message}}</div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                        <input class="form-control" placeholder=" " type="text" v-model="orderData.data.billing.fiscal_code" @focus="validation.billing.fiscal_code.state = null">
                                        <label class="placeholder h5"> {{$root.translateString('vat')}} </label>
                                        <div class="pristine-error" :class="validation.billing.fiscal_code.state == false ? 'invalid' : 'd-none'">{{validation.billing.fiscal_code.message}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="">

                            <div class="" v-if="orderData.data.billing.type == 'company'">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="email" v-model="billing.pec" @focus="validation.billing.pec.state = null">
                                            <label class="placeholder h5"> {{$root.translateString('pec')}} </label>
                                            <div class="pristine-error" :class="validation.billing.pec.state == false ? 'invalid' : 'd-none'">{{validation.billing.pec.message}}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="text" v-model="billing.sdi" @focus="validation.billing.sdi.state = null">
                                            <label class="placeholder h5"> {{$root.translateString('sdi')}} </label>
                                            <div class="pristine-error" :class="validation.billing.sdi.state == false ? 'invalid' : 'd-none'">{{validation.billing.sdi.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="" v-if="orderData.data.billing.type == 'company'">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="email" v-model="billing.address" @focus="validation.billing.address.state = null">
                                            <label class="placeholder h5"> {{$root.translateString('address')}} </label>
                                            <div class="pristine-error" :class="validation.billing.address.state == false ? 'invalid' : 'd-none'">{{validation.billing.address.message}}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="text" v-model="billing.city" @focus="validation.billing.city.state = null">
                                            <label class="placeholder h5"> {{$root.translateString('city')}} </label>
                                            <div class="pristine-error" :class="validation.billing.city.state == false ? 'invalid' : 'd-none'">{{validation.billing.city.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="" v-if="orderData.data.billing.type == 'company'">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                            <v-select
                                                @input="validation.billing.province.state = null"
                                                v-model="orderData.data.billing.province"
                                                :class="{'full' : (orderData.data.province != null && orderData.data.province != '')}"
                                                :options="provinces"
                                                label="value"
                                                index="label"
                                                :reduce="label => label.label"
                                            >
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        <small class="not-found">{{$root.translateString('no_results')}} <strong>{{ search }}</strong></small>
                                                    </template>
                                                </template>
                                            </v-select>
                                            <label class="placeholder h5"> {{$root.translateString('province')}} </label>
                                            <div class="pristine-error" :class="validation.address.province.state == false ? 'invalid' : 'd-none'">{{validation.address.province.message}}</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="number" v-model="orderData.data.billing.cap" @focus="validation.billing.cap.state = null">
                                            <label class="placeholder h5">  {{$root.translateString('cap')}} </label>
                                            <div class="pristine-error" :class="validation.billing.cap.state == false ? 'invalid' : 'd-none'">{{validation.billing.cap.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="orderData.data.billing.type != 'company'">
                                <div class="row">
                                    <div class="col-lg-24">
                                        <div class="form-wrapper mb-4 mb-lg-5 pb-xxl-1">
                                            <input class="form-control" placeholder=" " type="text" v-model="orderData.data.billing.fiscal_code" @focus="validation.billing.fiscal_code.state = null">
                                            <label class="placeholder h5">  {{$root.translateString('fiscal_code')}} </label>
                                            <div class="pristine-error" :class="validation.billing.fiscal_code.state == false ? 'invalid' : 'd-none'">{{validation.billing.fiscal_code.message}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--<div class="checkout-container-row-2__checkbox mt-2 mt-lg-5" v-if="!hide_save_billing_info || new_user.create_account">
                                <div class="checkbox-styles">
                                    <div class="checkbox">
                                        <input type="checkbox" id="save_billing_info" class="cb" name="save_billing_info" v-model="save_billing_info">
                                        <label for="save_billing_info"></label>
                                    </div>
                                    <div class="checkbox-styles__link checkout" @click="save_billing_info = !save_billing_info">
                                        <span>{{$root.translateString('update-billing-data')}}</span>
                                    </div>
                                </div>
                            </div>-->

                        </div>
                    </div>

                    <!-- payment -->

                    <div class="w-100 mt-5 pb-2">

                        <span class="h3 d-inline-block mt-0 mb-5 w-100 text-primary">
                            <span class="text-smaller-">
                                <span v-text="user.billing.require_invoice == false ? '03. ' : '04. '"></span> {{$root.translateString('payment_methods')}}
                            </span>
                        </span>

                        <div class="col-24">
                            <div class="row px-3">
                                <div class="col-24 align-items-center d-flex px-0 align-items-start border-top ">
                                    <div class="d-flex flex-grow-1 w-100 py-4">
                                        <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio checkbox--radio--bigger  text-left">
                                            <input required id="payment1" type="radio" name="payment_method" value="stripe" v-model="orderData.payment_method"/>
                                            <span class="mb-0">
                                                <label for="payment1" class="text-dark d-flex flex-column mb-0">
                                                    <span class="h6 h5-sm text-uppercase mb-1">{{$root.translateString('credit_card')}}</span>
                                                    <span class="h6 text-grey mb-0 pr-4" v-if="orderData.payment_method == 'stripe'">{{$root.translateString('credit_card_p')}}</span>
                                                    <img class="mt-2 d-sm-none" v-if="orderData.payment_method != 'stripe'" src="/images/payment_methods/stripe.svg" alt="Carta di credito" height="30" width="150"/>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-none d-sm-block">
                                        <img src="/images/payment_methods/stripe.svg" alt="Carta di credito" height="30" width="150"/>
                                    </div>
                                </div>
                                <!--<div class="col-24 align-items-center d-flex px-0 align-items-start border-top ">
                                    <div class="d-flex flex-grow-1 w-100 py-4">
                                        <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio checkbox--radio--bigger  text-left">
                                            <input required id="payment2" type="radio" name="payment_method" value="paypal" v-model="orderData.payment_method"/>
                                            <span class="mb-0">
                                                <label for="payment2" class="text-dark d-flex flex-column mb-0">
                                                    <span class="h6 h5-sm text-uppercase mb-1">PayPal</span>
                                                    <span class="h6 text-grey mb-0 pr-4" v-if="orderData.payment_method == 'paypal'">{{$root.translateString('paypal_p')}}</span>
                                                    <img class="mt-2 d-sm-none" v-if="orderData.payment_method != 'paypal'" src="/images/payment_methods/paypal.svg" alt="PayPal" height="30" width="48"/>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-none d-sm-block">
                                        <img src="/images/payment_methods/paypal.svg" alt="PayPal" height="30" width="48"/>
                                    </div>
                                </div>-->
                                <div class="col-24 align-items-center d-flex px-0 align-items-start border-top ">
                                    <div class="d-flex flex-grow-1 w-100 py-4">
                                        <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio checkbox--radio--bigger text-left">
                                            <input required id="payment3" type="radio" name="payment_method" value="bank" v-model="orderData.payment_method"/>
                                            <span class="mb-0">
                                                <label for="payment3" class="text-dark d-flex flex-column mb-0">
                                                    <span class="h6 h5-sm text-uppercase mb-1">{{$root.translateString('wire_transfer')}}</span>
                                                    <span class="h6 text-grey mb-0 pr-4" v-if="orderData.payment_method == 'bank'">{{$root.translateString('wire_transfer_p')}}</span>
                                                    <img class="mt-2 d-sm-none" v-if="orderData.payment_method != 'bank'" src="/images/payment_methods/bank.svg" alt="Bonifico" height="30" width="48"/>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-none d-sm-block">
                                        <img src="/images/payment_methods/bank.svg" alt="PayPal" height="30" width="48"/>
                                    </div>
                                </div>
                                <!-- <div class="col-24 align-items-center d-flex px-0 align-items-start border-top" v-if="paymentRequest != null">
                                    <div class="d-flex flex-grow-1 w-100 py-4">
                                        <div class="form-wrapper flex-grow-1 ml-0 checkbox checkbox--radio checkbox--radio--bigger  text-left">
                                            <input required id="payment4" type="radio" name="payment_method" value="applePay" v-model="orderData.payment_method"/>
                                            <span class="mb-0">
                                                <label for="payment4" class="text-dark d-flex flex-column mb-0">
                                                    <span class="h6 h5-sm text-uppercase mb-1">Apple Pay / Google Pay</span>
                                                    <span class="h6 text-grey mb-0 pr-4" v-if="orderData.payment_method == 'applePay'">{{$root.translateString('apple_pay_p')}}</span>
                                                    <img class="mt-2 d-sm-none" v-if="orderData.payment_method != 'applePay'" src="/images/payment_methods/pay.svg" alt="Apple Pay - Google Pay" height="30" width="100"/>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-none d-sm-block">
                                        <img src="/images/payment_methods/pay.svg" alt="Apple Pay - Google Pay" height="30" width="100"/>
                                    </div>
                                </div> -->

                                <div class="col-24 align-items-center d-flex px-0 align-items-start border-bottom"></div>

                            </div>
                        </div>

                    </div>

                    <!-- message -->
                    <!--
                    <div class="mt-5">
                        <span class="h3 d-inline-block mt-4 mb-5 w-100 text-primary">
                            <span class="text-smaller-">
                                <span v-text="user.billing.require_invoice == false ? '04. ' : '05. '"></span> {{$root.translateString('ask_for_gift_short')}}
                            </span>
                        </span>

                        <div class="w-100" v-if="isLogged && (user.addresses.length >= 1 && user.addresses[0].new === false)">
                            <div class="">
                                <div class="w-100" >
                                    <div class="w-100 cursor-pointer">
                                        <div class="">
                                            <img alt="icona" src="" width="9"/>
                                        </div>
                                        <v-select
                                            @input="manageSaveAddressCheckbox"
                                            :clearable="false"
                                            v-model="address"
                                            label="label"
                                            :class="{'full' : (user.addresses != null && user.addresses != '')}"
                                            :options="user.addresses"
                                            index="value"
                                        >
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    {{$root.translateString('no_results')}} <strong>{{ search }}</strong>
                                                </template>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="flex">
                                                    <div class="w-100">
                                                        {{ option.label }}
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                {{ option.label }}
                                            </template>
                                        </v-select>
                                        <label class="placeholder h5">
                                            {{$root.translateString('select-an-address')}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>-->

                        <!--<div class="row">
                            <div class="col-24">

                                <div class="row">
                                    <div class="col-12 col-sm-auto align-items-center">
                                        <div class="form-wrapper flex-grow-1 ml-0 checkbox text-left">
                                            <input required id="gift_message" type="checkbox" name="gift_message" v-model="giftPack.status"/>
                                            <span class="mb-0">
                                                <label for="gift_message" class="text-grey">
                                                    {{$root.translateString('ask_for_gift')}}
                                                </label>
                                            </span>
                                            <div class="pristine-error" :class="validation.new_user.privacy.state == false ? 'invalid' : 'd-none'">{{validation.new_user.privacy.message}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-wrapper mb-3">
                                    <textarea required name="message" autocomplete="off" placeholder=" " v-model="giftPack.message" class="form-control pt-2" style="height: 50px;" cols="60"></textarea>
                                    <label class="placeholder h5">{{$root.translateString('ask_for_gift')}}</label>
                                </div>

                            </div>
                        </div>

                    </div>-->

                </div>

                <div class="col-24 col-lg-16 offset-lg-4 offset-xl-0 col-xl-8 mt-5 mt-sm-55 mt-md-6 mt-lg-6 mt-xl-0">
                    <div class="side-panel">
                        <div class="border">
                            <!--<div class="border-bottom py-35" v-if="missing_for_free_shipping > 0">
                                <div class="px-4" v-if="missing_for_free_shipping < freeShippingAt">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="d-flex align-items-center justify-content-center img-flex-container">
                                            <img class="mr-2" alt="icona" src="/images/icone-19.svg" width="22"/>
                                        </div>
                                        <span class="pl-1 h6 mb-0 text-primary">
                                                {{$root.translateString('shipping-text')}} {{$root.currencyDisplay(freeShippingAt)}}
                                        </span>
                                    </div>
                                </div>
                                <div class="px-4" v-else>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="d-flex align-items-center justify-content-center img-flex-container">
                                            <img class="mr-2" alt="icona" src="/images/icone-19.svg" width="22"/>
                                        </div>
                                        <span class="pl-1 h6 h7-xxxl mb-0 text-primary">
                                            <span v-if="lang == 'it'">
                                               Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                                            </span>
                                            <span v-else>
                                               € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>-->

                            <div class="w-100 pt-3 px-4 border-bottom">
                                <div class="d-flex flex-column pt-1">

                                    <div class="w-100 d-flex product-line mb-3" v-for="(item, key) in orderData.products" :key="key">
                                        <img width="33" height="42" class="ml-n2 mt-1" :src="item.images[0]" :alt="item.name" />
                                        <div class="d-flex flex-column flex-grow-1 pl-2">
                                            <div class="d-flex flex-grow-1 pl-0 pt-0 w-100 ml-n2">
                                                <span class="pr-2 h-100 text-nowrap"></span>
                                                <span class="flex-grow-1 d-flex flex-column h5 pb-15">
                                                    <span class="text-uppercase">{{item.pivot.quantity}} <small>x</small> {{item.name}}</span>
                                                    <span class="w-100 text-grey h6 mb-0" v-if="item.type == 'vini'" v-text="item.combinations[0].attributes[0].value_label + ' - ' + item.combinations[0].attributes[1].value_label"></span>
                                                    <span class="w-100 text-grey h6 mb-0" v-else>Fanti</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="py-0 d-flex mt-0 pl-0">
                                            <span class="flex-grow-1 price text-nowrap h5">
                                                € {{ $root.currencyDisplaySimple(parseFloat(item.combinations[0].price) * parseInt(item.pivot.quantity)) }}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="totals px-4">
                                <div class="line d-flex h5 mt-4 mb-2 text-primary">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('subtotal')}}
                                    </span>
                                    <span>
                                        € {{ $root.currencyDisplaySimple(order.total_price + order.total_discount) }}
                                    </span>
                                </div>
                                <div class="line d-flex h5 mb-2 text-primary">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('shipping')}}
                                    </span>
                                    <span>
                                        <span v-if="order.shipment_price > 0">
                                         € {{ $root.currencyDisplaySimple(order.shipment_price) }}
                                        </span>
                                        <span v-else>{{$root.translateString('free')}}</span>
                                    </span>
                                </div>
                                <div class="line d-flex h5 mb-2 text-primary" v-if="order.duties_price > 0">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('duties')}}
                                    </span>
                                    <span v-if="order.duties_price > 0">
                                       € {{ $root.currencyDisplaySimple(order.duties_price) }}
                                    </span>
                                </div>
                                <div class="line d-flex h5 mb-2 text-primary" v-if="discount > 0">
                                    <span class="flex-grow-1">
                                        {{$root.translateString('discount')}}
                                    </span>
                                    <span>
                                        € {{ $root.currencyDisplaySimple(order.total_discount) }}
                                    </span>
                                </div>
                                <div class="line d-flex text-grey py-35 mb-2">
                                    <span class="flex-grow-1">
                                        <span class="h4 text-dark">{{$root.translateString('total')}}</span>
                                        &nbsp;
                                        <span class="h6">
                                            <small>({{$root.translateString('tax_included')}})</small>
                                        </span>
                                    </span>
                                    <span>
                                        <span class="h4 text-dark">€ {{ $root.currencyDisplaySimple(order.final_price) }}</span>
                                    </span>
                                </div>
                                <div class="line d-flex mb-35 text-grey">
                                    <!-- v-if="orderData.payment_method != 'applePay'" -->
                                    <button type="button" class="btn btn-primary w-100 text-uppercase font-alternate" @click="updateOrderAndPay" :class="{'loading' : loading}" :disabled="btn_disabled">
                                        <span>{{$root.translateString('complete_order')}}</span>
                                    </button>
                                    <!-- <a class="btn btn-primary w-100 text-uppercase font-alternate" v-else @click="paymentRequest.show();updateOrderAndPay()" href="javascript:void(0)" :class="{'loading' : loading}" :disabled="btn_disabled">
                                        <span>{{$root.translateString('complete_order')}}</span>
                                    </a> -->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </section>
</template>

<script>
export default {
    props: ['lang', 'provinces', 'countries', 'order', 'isLogged', 'blockCountrySelect', 'userProp'],
    data() {
        return {
            orderData: null,
            user: {
                addresses: [],
                billing: {
                    require_invoice: true,
                    data: {
                        type: 'private',
                        name: '',
                        fiscal_code: '',
                        sdi: '',
                        pec: '',
                        address: '',
                        city: '',
                        cap: '',
                        province: '',
                        country: 'IT',
                    }
                },
            },
            hide_save_billing_info: true,
            save_billing_info: false,
            save_new_address: false,
            hide_save_address: true,
            new_user: {
                name: '',
                email: '',
                password: '',
                confirm_password: '',
                create_account: false,
            },
            hasGift: false,
            stripeObject: null,
            paymentRequest: null,
            loading: false,
            pay: {
                method: 'stripe'
            },
            discount_placeholder: true,
            giftPack: {
                status: true,
                message: '',
            },
            address: {
                name: '',
                address: '',
                city: '',
                cap: '',
                province: '',
                country: 'IT',
            },
            billing: {
                type: 'company', //normally is private, here we forced company
                name: '',
                fiscal_code: '',
                sdi: '',
                pec: '',
                address: '',
                city: '',
                cap: '',
                province: '',
                country: 'IT',
            },
            discountCode: '',
            cart: null,
            shipping: 0,
            discount: 0,
            count: 0,
            showDiscountBox: false,
            missing_for_free_shipping: 0,
            validation: {
                new_user: {
                    name: {
                        state: null,
                        message: '',
                    },
                    email: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    password: {
                        state: null,
                        message: '',
                    },
                    password_confirmation: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
                address: {
                    name: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    address: {
                        state: null,
                        message: '',
                    },
                    email: {
                        state: null,
                        message: '',
                    },
                    city: {
                        state: null,
                        message: '',
                    },
                    cap: {
                        state: null,
                        message: '',
                    },
                    province: {
                        state: null,
                        message: '',
                    },
                    country: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
                billing: {
                    name: {
                        state: null,
                        message: '',
                    },
                    fiscal_code: {
                        state: null,
                        message: '',
                    },
                    sdi: {
                        state: null,
                        message: '',
                    },
                    pec: {
                        state: null,
                        message: '',
                    },
                    address: {
                        state: null,
                        message: '',
                    },
                    city: {
                        state: null,
                        message: '',
                    },
                    cap: {
                        state: null,
                        message: '',
                    },
                    province: {
                        state: null,
                        message: '',
                    },
                },
                discount: {
                    state: null,
                    message: ''
                },
            },
            btn_disabled: false,
            profile_loaded: false,
            billing_memo: null,
        }
    },
    watch: {
        'orderData.data.ship.privacy' : {
            handler: function (n, o) {
                if(n) {
                    this.validation.address.privacy.state = null;
                }
            },
            deep: true,
        }
    },
    created() {
        this.orderData = _.cloneDeep(this.order);

        if(typeof this.orderData.data.ship == 'undefined' || this.orderData.data.ship == null) {
            this.orderData.data.ship = {
                name: '',
                address: '',
                email: '',
                city: '',
                cap: '',
                province: '',
                country: '',
                privacy: false,
                invoice: false,
            }
        }

        if(typeof this.orderData.data.billing == 'undefined' || this.orderData.data.billing == null) {
            this.orderData.data.billing = {
                type: 'private',
                name: '',
                fiscal_code: '',
                sdi: '',
                pec: '',
                address: '',
                city: '',
                cap: '',
                province: '',
            }
        }

        if(typeof this.orderData.data.giftPack == 'undefined' && this.orderData.data.giftPack == null) {
            this.giftPack.status = true;
            this.giftPack.message = this.orderData.data.giftPack;

        }
    },
    mounted() {

        if(!this.shouldBeShipped) {
            this.hide_save_address = true;
        }

        this.new_user.name = this.orderData.data.ship.name;
        this.new_user.email = this.orderData.data.ship.email;

        if($('.side-panel').length) {

            let top = document.querySelector('.side-panel').getBoundingClientRect().top;
            let width = 0;
            let left = $('.side-panel').offset().left;
            let bounds = document.querySelector('.side-panel').getBoundingClientRect();

            function setSideMenu() {

                if ($(window).width() <= 991) {
                    return false;
                }

                if (window.scrollY < top - 21) {
                    $('.side-panel').removeClass('position-fixed');
                    $('.side-panel').css('top', '');
                    $('.side-panel').css('width', '');
                    $('.side-panel').css('left', '');
                } else {
                    $('.side-panel').addClass('position-fixed');

                    let ch = $('.side-panel').height();

                    let fp = $('.container-section > .container > .row').get(0).getBoundingClientRect().top + $('.container-section > .container > .row').height() - 15;

                    if (fp < (ch + 20)) {

                        let ofst = -(ch - fp)

                        $('.side-panel').css('top', ofst);
                    } else {
                        $('.side-panel').css('top', 20);
                    }

                    $('.side-panel').css('width', width);
                    $('.side-panel').css('left', left);
                }

            }

            setTimeout(() => {

                if ($('.side-panel').length && $(window).width() >= 1200) {

                    top = document.querySelector('.side-panel').getBoundingClientRect().top;
                    width = $('.side-panel').outerWidth();

                    if ($('.side-panel').length) {
                        setSideMenu();
                    }

                    window.addEventListener('scroll', function() {

                        if ($('.side-panel').length) {
                            setSideMenu();
                        }
                    });

                    $(window).on('resize', () => {

                        $('html,body').animate({
                            scrollTop: 0,
                        },'fast');
                        $('.side-panel').removeClass('position-fixed');
                        $('.side-panel').css('top', '');
                        $('.side-panel').css('width', '');
                        $('.side-panel').css('left', '');

                        if ($(window).width() >= 1200) {

                            top = document.querySelector('.side-panel').getBoundingClientRect().top;
                            width = $('.side-panel').outerWidth();

                            if ($('.side-panel').length) {
                                setSideMenu();
                            }

                        } else {

                            $('.side-panel').removeClass('position-fixed');
                            $('.side-panel').css('top', '');
                            $('.side-panel').css('width', '');
                            $('.side-panel').css('left', '');

                        }

                    });

                }

            }, 500);

        }

        this.loadStripe();
    },
    methods: {
        summonPopup() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            setTimeout(() => {
                this.$eventHub.$emit('login', {'hide_register': true});
            }, 400)
        },
        manageSaveAddressCheckbox() {
            if(this.address.new) {
                this.hide_save_address = false;
            } else {
                this.hide_save_address = true;
                this.save_new_address = false;
            }
        },
        toggleLogin() {
            this.$eventHub.$emit('login', {});
        },
        getValueFromAttributes(string, key, value) {

            let json = JSON.parse(string);
            let found = '';

            if(key == 'visit' ) {

                Object.keys(json.visit).forEach((elem2, index) => {
                    if( elem2 == value ) {
                        found = json.visit[elem2];
                    }
                })

            }else{
                Object.keys(json.attributes).forEach((elem2, index) => {

                    if(json.attributes[elem2] != null) {

                        Object.keys(json.attributes[elem2]).forEach((elem3, index2) => {
                            if( json.attributes[elem2][elem3] == key) {
                                if(typeof json.attributes[elem2][value] != 'undefined') {
                                    //console.log(json.attributes[elem2][value]);
                                    found = json.attributes[elem2][value];
                                }
                            }
                        });

                    }

                });
            }

            return found;
        },
        loadStripe() {
            axios.get('/api/cart/stripe')
                .then(response => {
                    this.stripeObject = Stripe(response.data.pkey);

                    var paymentRequest = this.stripeObject.paymentRequest({
                        country: 'IT',
                        currency: 'eur',
                        total: {
                            label: 'Ordine Shop Azienda Agricola Fanti',
                            amount: parseInt(parseFloat(this.order.final_price) * 100),
                        },
                        requestPayerName: true,
                        requestPayerEmail: true,
                    });

                    // Check the availability of the Payment Request API first.
                    paymentRequest.canMakePayment().then(result => {
                        if (result) {
                            this.paymentRequest = paymentRequest;
                        } else {
                            this.paymentRequest = null
                        }
                    });
                })
        },
        updateOrderAndPay()
        {
            this.btn_disabled = true;
            if(this.canProceed()){
                this.loading = true;
                axios.post('/api/cart/update-order', {
                    lang: this.lang,
                    order_id: this.orderData.id,
                    token: this.orderData.token,
                    pay: this.orderData.payment_method,
                    address: this.orderData.data.ship,
                    billing: this.orderData.data.billing,
                    giftPack: this.giftPack,
                    require_invoice: this.user.billing.require_invoice,
                    new_user: this.new_user,
                    save_new_address: this.save_new_address,
                    save_billing_info: this.save_billing_info,
                })
                    .then(response => {
                        if(response.data.action == 'stripe_js') {
                            //var stripe = Stripe(response.data.pkey);
                            this.stripeObject.redirectToCheckout({
                                sessionId: response.data.payment_intent
                            }).then(function (result) {
                                //(result.error.message)
                                this.btn_disabled = false;
                            });
                        } else if(response.data.action == 'stripe_apple_pay') {
                            var stripe = this.stripeObject;
                            var clientSecret = response.data.client_secret;
                            var confirm_page = response.data.confirm_page;
                            this.paymentRequest.on('paymentmethod', ev => {
                                stripe.confirmCardPayment(
                                    clientSecret,
                                    {payment_method: ev.paymentMethod.id},
                                    {handleActions: false}
                                ).then(function(confirmResult) {
                                    //console.log(confirmResult);
                                    if (confirmResult.error) {
                                        ev.complete('fail');
                                    } else {
                                        ev.complete('success');
                                        stripe.confirmCardPayment(response.data.client_secret).then(function(result) {
                                            if (result.error) {
                                                // The payment failed -- ask your customer for a new payment method.
                                            } else {
                                                window.location.href = confirm_page;
                                            }
                                        });
                                    }
                                });
                            });
                        } else if(response.data.action == 'redirect') {
                            window.location.href = response.data.next_action;
                        }
                    }).catch(e => {
                    console.log(e);
                    return;
                    if(typeof e.response.data.location != 'undefined') {
                        window.location.href = e.response.data.location;
                    } else {
                        location.reload(true);
                    }
                })
            }
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        },
        canProceed(){

            let is_invalid = false;

            if(!this.isLogged) {

                Object.keys(this.validation.new_user).forEach((elem, key) => {
                    this.validation.new_user[elem].message = '';
                    this.validation.new_user[elem].state = null;
                });

                let is_new = (typeof this.order.user_id == 'undefined' || this.order.user_id == null);

                if (this.new_user.name == '' && is_new) {
                    if(this.lang == 'it') {
                        this.validation.new_user.name.message = 'Questo campo non può essere vuoto.';
                    }else{
                        this.validation.new_user.name.message = 'This field cannot be empty.';
                    }
                    this.validation.new_user.name.state = false;
                    is_invalid = true;
                }else{
                    this.validation.new_user.name.state = null;
                }

                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let disposable = require('is-disposable-email');
                if (! re.test(this.new_user.email)) {
                    if(this.lang == 'it') {
                        this.validation.new_user.email.message = 'Non sembra un indirizzo email valido.';
                    }else{
                        this.validation.new_user.email.message = 'The email address is invalid.';
                    }
                    this.validation.new_user.email.state = false;
                    is_invalid = true;
                } else {
                    if (disposable(this.new_user.email)) {
                        if(this.lang == 'it') {
                            this.validation.new_user.email.message = 'Tipologia di servizio email non valido.';
                        }else{
                            this.validation.new_user.email.message = 'You email provider is invalid.';
                        }
                        this.validation.new_user.email.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.email.state = null;
                    }
                }

                if (this.new_user.create_account && is_new) {

                    if (this.new_user.password == '') {
                        if(this.lang == 'it') {
                            this.validation.new_user.password.message = 'Questo campo non può essere vuoto.';
                        }else{
                            this.validation.new_user.password.message = 'This field cannot be empty.';
                        }
                        this.validation.new_user.password.state = false;
                        is_invalid = true;
                    }else{
                        this.validation.new_user.password.state = null;
                    }

                    if (this.new_user.password_confirmation != this.new_user.password || this.user.password_confirmation == '') {
                        if(this.lang == 'it') {
                            this.validation.new_user.password_confirmation.message = 'Questo campo deve coincidere con la password.';
                        }else{
                            this.validation.new_user.password_confirmation.message = 'Questo campo non può essere vuoto.';
                        }
                        this.validation.new_user.password_confirmation.state = false;
                        is_invalid = true;
                    }else{
                        this.validation.new_user.password_confirmation.state = null;
                    }

                }

                if(!this.new_user.privacy && is_new) {
                    if(this.lang == 'it') {
                        this.validation.new_user.privacy.message = 'È necessario accettare i termini.';
                    }else{
                        this.validation.new_user.privacy.message = 'You need to accept the terms.';
                    }
                    this.validation.new_user.privacy.state = false;
                    is_invalid = true;
                }

            }

            Object.keys(this.validation.address).forEach((elem, key) => {
                this.validation.address[elem].message = '';
                this.validation.address[elem].state = null;
            });

            Object.keys(this.validation.billing).forEach((elem, key) => {
                this.validation.billing[elem].message = '';
                this.validation.billing[elem].state = null;
            });

            if(this.shouldBeShipped) {
                $.each(this.orderData.data.ship, (key, elem) => {
                    if(typeof this.validation.address[key] != 'undefined') {
                        if(elem == '') {

                            if (this.lang == 'it') {
                                this.validation.address[key].message = 'Il campo è obbligatorio';
                            } else {
                                this.validation.address[key].message = 'This field is required';
                            }

                            this.validation.address[key].state = false;
                            is_invalid = true;
                        }
                    }
                });
            }

            /*if(!this.orderData.data.ship.privacy) {
                if(this.lang == 'it') {
                    this.validation.address.privacy.message = 'È necessario accettare i termini per proseguire';
                }else{
                    this.validation.address.privacy.message = 'You need to accept the terms to proceed';
                }
                this.validation.address.privacy.state = false;
                is_invalid = true;
            }*/

            if(this.orderData.data.ship.invoice) {

                if(this.orderData.data.billing.type == 'company') {

                    $.each(this.orderData.data.billing, (key, elem) => {
                        if(elem == '' && key != 'sdi' && key != 'pec'){
                            if(this.lang == 'it') {
                                this.validation.billing[key].message = 'Il campo è obbligatorio';
                            }else{
                                this.validation.billing[key].message = 'This field is required';
                            }
                            this.validation.billing[key].state = false;
                            is_invalid = true;
                        }
                    });

                    if(this.orderData.data.billing.sdi == '' && this.orderData.data.billing.pec == '') {
                        if(this.lang == 'it') {
                            this.validation.billing.pec.message = 'Compila PEC o Codice univoco';
                            this.validation.billing.sdi.message = 'Compila PEC o Codice univoco';
                        }else{
                            this.validation.billing.pec.message = 'Either one between PEC or SDI is required';
                            this.validation.billing.sdi.message = 'Either one between PEC or SDI is required';
                        }
                        this.validation.billing.pec.state = false;
                        this.validation.billing.sdi.state = false;

                        is_invalid = true;
                    }

                }else{
                    if(this.orderData.data.billing.fiscal_code == '') {
                        if(this.lang == 'it') {
                            this.validation.billing.fiscal_code.message = 'Il campo è obbligatorio';
                        }else{
                            this.validation.billing.fiscal_code.message = 'This field is required';
                        }
                        this.validation.billing.fiscal_code.state = false;
                        is_invalid = true;
                    }
                }

            }

            if(is_invalid) {

                setTimeout(
                    () => {

                        this.btn_disabled = false;

                        let elements = document.querySelectorAll('.invalid-feedback');

                        window.scroll({
                            top: parseInt(elements[0].getBoundingClientRect().top + window.scrollY) - 150,
                            behavior: "smooth",
                        });

                    }
                    , 500);

                return false;
            }

            return true;

        }
    },
    computed: {
        shouldBeShipped() {
            return this.order.should_be_shipped;
        },
        price() {
            let p = 0;

            if(this.cart != null) {
                for (let [key, item] of Object.entries(this.cart)) {
                    if(this.isNotEmpty(item)) {
                        if(typeof item.subtotal != 'undefined') {
                            p += parseFloat(item.subtotal);
                        } else {
                            p += parseFloat(item.price) * parseFloat(item.pivot.quantity);
                        }
                    }
                }
            }

            return p + this.shipping;
        }
    }
}
</script>

<style lang="scss">

.v-select {

    .vs__dropdown-toggle{
        padding: 0 !important;
        background: none !important;
        border: 0 !important;
    }

    .vs__selected-options{
        padding:0px !important;
    }

    .vs__actions{
        display: none !important;
    }

    .vs__dropdown-menu{
        top: 50px !important;
        border: 0;
        box-shadow: none;
        background: #000000;

        &::-webkit-scrollbar {
            width: 4px; /* For Chrome, Safari, and Opera */
        }

    }

    /*.vs__search, .vs__search:focus{
        background: transparent;
        border: 0;
        border-bottom: 1px solid #c9c8c0;
        outline: none !important;
        color: #b4b3aa;
        padding: 7px 2px;
        font-size: 1rem;
        width: 100%;
        font-family: "europa", sans-serif;
        margin: 4px;
        margin-left: 0px;
        margin-right: 0px;
    }*/

    .not-found{
        color:#ffffff !important;
        font-size: .9rem !important;
    }

    .vs__dropdown-option{
        padding: 6px 20px;
        color: #ffffff;
        background: none;

        &:hover{
            color: rgba(255, 255, 255, .7);
        }

    }

    & ~ label.placeholder{
        /*position: absolute;
        left: 0.6rem;
        width: calc(100%);
        height: 21px;
        top: 14px;
        margin: auto;
        font-weight: 300;
        color: #b0b0b0;
        pointer-events: none;
        transition: all 0.1s;
        z-index: 10;
        text-align: left;
        font-weight: 300;*/
    }

    &.vs--open, &.full{

        & ~ label.placeholder{
            top: 0px;
            text-transform: uppercase;
            transition: all 0.1s;
            -moz-transition: all 0.1s;
            -webkit-transition: all 0.1s;
            font-size: 78%;
        }

    }

    .vs__selected{
        margin: 0;
        position: absolute;
        left: 0;
        top: 13px;
        color: #000000;
        padding: 0.375rem 0rem;
        font-size: 1.15rem;
    }

}

</style>
